import {
    Appenders,
    LogLevel,
} from './components/providers/logger/logger-types';

// When running locally, get settings from the .env file
// In production, these settings are injected into the index.html file by neon-app-server
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
    window._env = process.env;
}

const get = (name: string): string => {
    const value = window._env[name];
    if (!value)
        throw new Error('Environment variable ' + name + ' does not exist');
    return value;
};

const getSilently = (name: string): string | undefined => window._env[name];

const basePath = require('../package.json').homepage;
const baseUrl = get('REACT_APP_HOST') + basePath;

export const config = {
    auth0: {
        clientId: get('REACT_APP_AUTH_CLIENT_ID'),
        domain: get('REACT_APP_AUTH_DOMAIN'),
        audience: get('REACT_APP_AUTH_AUDIENCE'),
        redirectUri: baseUrl + '/callback',
        returnToUri: baseUrl + '/loggedout',
        namespace: 'https://' + get('REACT_APP_AUTH_DOMAIN') + '/',
    },
    basePath,
    baseUrl,
    serverUrl: get('REACT_APP_SERVER_URL'),
    landingPageUrl: get('REACT_APP_LANDING_PAGE_URL'),
    premiumContentPageUrl:
        get('REACT_APP_LANDING_PAGE_URL') + '/neonpremiumcontenttermsofservice',
    loginPageUrl: get('REACT_APP_LOGIN_PAGE'),
    nodeEnv: get('NODE_ENV'),
    deployEnv: getSilently('REACT_APP_ENVIRONMENT'),
    logging: {
        level: LogLevel.INFO,
        appenders: [
            ...(window._env['REACT_APP_LOG_TO_CONSOLE'] === 'true'
                ? [Appenders.console]
                : []),
            ...(window._env['REACT_APP_LOG_TO_SERVER'] === 'true'
                ? [Appenders.ajax]
                : []),
        ],
        addTimeStamp: true,
        endpoint: get('REACT_APP_LOG_ENDPOINT'),
        batchTimeoutMs: 2000,
        batchSize: 10,
        maxBatchSize: 100,
    },
    trialDays: +(getSilently('REACT_APP_USER_TRIAL_PERIOD_DAYS') || '14'),
    defaultTrialChannelSubscriptionDays: 14,
    numberOfDaysToShowExpiryBanner: +(
        getSilently('REACT_APP_NUMBERS_OF_DAYS_TO_SHOW_EXPIRY_BANNER') || '7'
    ),
    minTrialDays: 1,
    maxTrialDays: 100,
    agGridLicense: get('REACT_APP_AGGRID_LICENSE'),
    premiumChannelsEnabled:
        window._env['REACT_APP_PREMIUM_CHANNELS'] === 'true',
    premiumFeatures: window._env['REACT_APP_PREMIUM_FEATURES'] === 'true',
    stripePaymentsEnabled:
        window._env['REACT_APP_ENABLE_STRIPE_PAYMENTS'] === 'true',
    stripeKey: get('REACT_APP_STRIPE_PUBLISHABLE_KEY'),
    editorAutoSaveInterval: +(
        getSilently('REACT_APP_EDITOR_AUTOSAVE_INTERVAL') || 3000
    ),
    tableauUrl: get('REACT_APP_TABLEAU_URL'),
};

export const DEFAULT_CHANNEL_COVER_DARK_MODE = `${config.basePath}/images/default-channel-cover-dark-mode.png`;
export const DEFAULT_CHANNEL_COVER_LIGHT_MODE = `${config.basePath}/images/default-channel-cover-light-mode.png`;
export const MAREX_WATERMARK = `${config.basePath}/images/Marex-watermark.png`;
export const MAREX_WATERMARK_DARK = `${config.basePath}/images/Marex-watermark-dark.png`;
export const CALL_TO_ACTION = `${config.basePath}/images/call-to-action.svg`;
export const CHARTS_LOGO = `${config.basePath}/images/chart-icon.svg`;
